import { STEP_DAY, STEP_TIME, EVENT_STEP_CHANGE } from 'directives/userInputs/userInputAvailabilitySpecific';

export const AvailabilityGroupStepController = ['$scope',
    function ($scope) {
        $scope.groupName = "Availability";
        $scope.hideNav = false;
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 1; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/availability.html';

        // if the localStep is -1, we need to go to the very last step
        if ($scope.localStep === -1) {
            $scope.localStep = $scope.finalStep;
        }

        $scope.hasFairTypeServices = false;
        let services = $scope.registrationData.get('VerticalServices');
        services.models.forEach(service => {
            if (service.isFairType) {
                $scope.hasFairTypeServices = true;
            }
        });

        if ($scope.registrationSettings.WhitelabelSettings['hideField:professionalInfo_userInputAvailability']){
            $scope.localStep = $scope.finalStep + 1;
            $scope.skipThisStep();
        }

        switch ($scope.localStep) {
            case 0:
                $scope.$watch(function() {
                    return $scope.registrationData.get('GeneralAvailability').length;
                }, function(newVal) {
                    $scope.showNext = newVal;
                });

                if ($scope.hasFairTypeServices) {
                    $scope.$on(EVENT_STEP_CHANGE, (evt, currentStep) => {
                        $scope.hideNext = (currentStep === STEP_TIME);
                    });
                }
                break;
            case 1:
                if ($scope.registrationData.get('Programs').length === 0) {
                    $scope.skipThisStep();
                } else if ($scope.registrationSettings.WhitelabelSettings.allowExpertProgramsChoice === false) {
                    $scope.skipThisStep();
                }
                $scope.showNext = true;
                break;
        }
    }
];
